import { AxiosError } from 'axios';
import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import LoginService from '@/LoginService'
import ResetPasswordService from '@/ResetPasswordService';
import ResetPasswordInfo from '@/ResetPasswordInfo';
import RegistrationService from '@/RegistrationService'
import ErrorHelper from '@/ErrorHelper'
import PasswordHelper from './PasswordHelper';

export default Vue.component('loginform', {
    props: {
        initialOperation: Number,
        initialWantsToUpgrade: Boolean,
        gpxAsString: String
    },
    data: () => ({
        email: "",
        password: "",
        confirmpassword: "",
        userError: "",
        operations: [ "Login", "Register", "Reset" ],
        operation: 0,
        loading: false,
        snackbar: false,
        snackbarText: '',
        snackbarColor: '',
        wantsToUpgrade: false,
        loginPostUrl: LoginService.loginPostUrl()
    }),
    mounted: function () {
        this.operation = this.initialOperation ?? 0
        this.wantsToUpgrade = this.initialWantsToUpgrade
        setTimeout(() => {
            const emailTextField = document.getElementById("emailTextField") as HTMLInputElement
            if(emailTextField) {
                emailTextField.focus()
            }
        })

        //deal with password manager foibles (doesn't change property when populated with 1password)
        const passwordField = document.getElementById('password') as HTMLInputElement
        passwordField.addEventListener('change', () => {
            this.password = passwordField.value
        })
    },
    methods: {
        clearFields: function () {
            this.email = ""
            this.password = ""
            this.confirmpassword = ""
        },
        showError: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = 'error'
        },
        showInfo: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = ''
        },
        canLogin: function() {
            return (!!this.email) && (!!this.password)
        },
        login: async function () {
            this.loading = true // should post/redirect/get, so given that DOM will be torn down, no need to reset flag
        },
        canRegister: function() {
            return (!!this.email) && (!!this.password) && (!!this.confirmpassword)
        },
        register: async function () {
            if(!PasswordHelper.isValid(this.password, this.confirmpassword, this.showError))  {
                return
            }

            try {
                this.loading = true
                const resp = await RegistrationService.register({
                    email: this.email,
                    password: this.password,
                    wantsToUpgrade: this.wantsToUpgrade
                })
                this.close(resp.data)
            }
            catch (error) {
                ErrorHelper.ifUserError(error, (userError) => this.showError(userError)) ||
                    this.showError('An error occurred registering.')
            }
            finally {
                this.loading = false
            }
        },
        canReset: function() {
            return (!!this.email)
        },
        reset: async function () {
            this.loading = true
            try {
                const resp = await ResetPasswordService.requestResetToken({ email: this.email })
                this.close(resp.data)
            }
            catch (error) {
                ErrorHelper.ifUserError(error, (userError) => this.showError(userError)) ||
                    this.showError('An error occurred resetting the password.')
            }
            finally {
                this.loading = false
            }
        },
        close: function (message: string | null) {
            this.$emit('close', message);
        },
        enterPressed: async function() {
            if(this.operations[this.operation] === 'Register') {
                if(this.canRegister()) {
                    this.register()
                }
            }
            else if (this.operations[this.operation] === 'Reset') {
                if(this.canReset()) {
                    this.reset();
                }
            }
        }
    }
});
